import { useEffect, useRef, useState } from 'react';

const testimonials = [
  {
    id: 1,
    name: '田中 彩香',
    role: '挙式2024年3月',
    comment: '結婚式のブーケとテーブルフラワーをお願いしました。希望のイメージを伝えると、それ以上の素晴らしい作品を仕上げてくださいました。当日はゲスト全員が花の美しさに感動していました。',
    image: 'https://public.readdy.ai/ai/img_res/88f91bc7cdbf30814d79b988c8df96a1.jpg',
    stars: 5,
  },
  {
    id: 2,
    name: '鈴木 美里',
    role: 'フラワーレッスン受講生',
    comment: 'フラワーアレンジメントをゼロから学びたくてレッスンを受講しました。先生の丁寧な指導おかげで、初回から素敵な作品が作れました。月1回のレッスンが今では楽しみで仕方ありません！',
    image: 'https://readdy.ai/api/search-image?query=Young%20Japanese%20woman%20portrait%20smiling%20holding%20flower%20bouquet%2C%20casual%20elegant%20style%2C%20natural%20soft%20lighting%2C%20warm%20and%20friendly%20expression%2C%20wearing%20light%20colored%20top%2C%20clean%20minimal%20background%2C%20lifestyle%20photography&width=200&height=200&seq=bloom-review-2&orientation=squarish',
    stars: 5,
  },
  {
    id: 3,
    name: '渡辺 恵',
    role: '定期フラワーご利用',
    comment: '毎月届く季節のお花に癒されています。センスが良くて、種類も毎回変えてくださるので楽しみです。部屋に花があるだけで本当に気持ちが豊かになります。これからも続けたいと思っています。',
    image: 'https://readdy.ai/api/search-image?query=Sophisticated%20Japanese%20woman%20in%20her%2040s%20portrait%2C%20gentle%20smile%2C%20natural%20makeup%2C%20wearing%20elegant%20casual%20clothes%2C%20holding%20flowers%2C%20soft%20warm%20interior%20background%2C%20lifestyle%20photography%2C%20mature%20and%20refined%20aesthetic&width=200&height=200&seq=bloom-review-3&orientation=squarish',
    stars: 5,
  },
  {
    id: 4,
    name: '佐藤 ひかる',
    role: '誕生日プレゼントにご利用',
    comment: '母へのプレゼントにアレンジメントを注文。電話で伝えた希望を完璧に形にしてくれました。母も大喜びで、しばらく飾っていたと連絡をくれました。特別な贈り物として最高でした！',
    image: 'https://readdy.ai/api/search-image?query=Young%20cheerful%20Japanese%20woman%20portrait%20with%20warm%20smile%2C%20bright%20expressive%20eyes%2C%20wearing%20pink%20floral%20dress%2C%20colorful%20soft%20background%2C%20natural%20daylight%2C%20joy%20and%20happiness%20expression%2C%20portrait%20photography&width=200&height=200&seq=bloom-review-4&orientation=squarish',
    stars: 5,
  },
  {
    id: 5,
    name: '伊藤 真奈美',
    role: '挙式2023年11月',
    comment: 'ガーデンウェディングの装花を全てお任せしました。ヴィンテージテイストのご提案が素晴らしく、思い描いていた以上の式場に仕上がりました。打ち合わせから当日まで、とても安心してお任せできました。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20newlywed%20woman%20portrait%2C%20soft%20natural%20beauty%2C%20wearing%20white%20bridal%20gown%2C%20holding%20small%20bouquet%20of%20flowers%2C%20outdoor%20garden%20setting%20with%20soft%20bokeh%20greenery%20background%2C%20romantic%20and%20peaceful%20expression&width=200&height=200&seq=bloom-review-5&orientation=squarish',
    stars: 5,
  },
];

export default function TestimonialsSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="testimonials" ref={ref} className="py-24 lg:py-36 px-6 lg:px-12 bg-[#f5ede0]">
      <div className="max-w-7xl mx-auto">
        <div className={`text-center mb-16 transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="font-noto text-xs tracking-[0.4em] text-[#c4956a] uppercase mb-4">Testimonials</p>
          <h2 className="font-cormorant text-5xl lg:text-6xl text-[#2c2218] font-light">お客様の声</h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.slice(0, 3).map((t, i) => (
            <div
              key={t.id}
              className={`bg-white rounded-2xl p-8 transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${i * 120 + 200}ms` }}
            >
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.stars }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#c4956a] text-sm"></i>
                ))}
              </div>
              <p className="font-noto text-sm text-[#6b5c4e] leading-relaxed mb-6">&ldquo;{t.comment}&rdquo;</p>
              <div className="flex items-center gap-4 border-t border-[#f0e8de] pt-5">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img src={t.image} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <p className="font-noto text-sm font-medium text-[#2c2218]">{t.name}</p>
                  <p className="font-noto text-xs text-[#c4956a] tracking-wider">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Second row - 2 centered */}
        <div className="grid md:grid-cols-2 gap-6 mt-6 lg:max-w-3xl lg:mx-auto">
          {testimonials.slice(3, 5).map((t, i) => (
            <div
              key={t.id}
              className={`bg-white rounded-2xl p-8 transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${(i + 3) * 120 + 200}ms` }}
            >
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.stars }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#c4956a] text-sm"></i>
                ))}
              </div>
              <p className="font-noto text-sm text-[#6b5c4e] leading-relaxed mb-6">&ldquo;{t.comment}&rdquo;</p>
              <div className="flex items-center gap-4 border-t border-[#f0e8de] pt-5">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img src={t.image} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <p className="font-noto text-sm font-medium text-[#2c2218]">{t.name}</p>
                  <p className="font-noto text-xs text-[#c4956a] tracking-wider">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
